module.exports = __webpack_public_path__ + "img/arena.e1af4f19.png";